import React, { ChangeEvent } from 'react';
import { ITimeZoneDTO } from '../../../api/timezones.dao';
import { connectGlobalVM } from '../../global.context';
import './select-timezones.scss';
import { timezonesCodeLabelMap } from '../../../infrastructure/timezones-code-label-map';

interface ISelectTimezonesOwnProps {
    value: string;
    onChange: (value: string) => void;
    onReady?: (timeZones: Readonly<ITimeZoneDTO[]>) => void;
    className?: string;
    placeHolder?: string | JSX.Element;
    placeHolderDisabled?: boolean;
    placeHolderHidden?: boolean;
}

interface ISelectTimezonesGlobalProps {
    timeZones: Readonly<ITimeZoneDTO[]>;
    setSelectedTimezone: (timezoneCode: string) => void;
}

class SelectTimezonesPresentation extends React.Component<ISelectTimezonesOwnProps & ISelectTimezonesGlobalProps> {
    public componentDidUpdate(prevProps) {
        if (this.props.timeZones
            && this.props.onReady
            && (!prevProps.timeZones || prevProps.onReady!)
        ) {
            this.props.onReady(this.props.timeZones);
        }
    }

    public componentDidMount(): void {
        if (this.props.value) {
            this.props.setSelectedTimezone(this.props.value);
        }
    }

    public componentWillUnmount(): void {
        this.props.setSelectedTimezone(null);
    }

    public render() {
       const placeHolderDisabled = this.props?.placeHolderDisabled ?? true;
       const placeHolderHidden = this.props?.placeHolderHidden ?? true;

       if (!this.props.timeZones || !this.props.timeZones.length) {
           return (
               <input
                   type='text'
                   className={`timezones-not-ready-placeholder ${this.props.className}`}
                   value={this.props.value}
                   readOnly={true}
               />
           );
       }

       return (
           <select
               className={`timezones-ready-select ${this.props.className}`}
               value={this.props.value}
               onChange={this.changeHandler}
           >
               {this.props.placeHolder && <option value={''} disabled={placeHolderDisabled} hidden={placeHolderHidden}>{this.props.placeHolder}</option>}
               {
                   this.props.timeZones && this.props.timeZones.map(timeZoneItem => {
                       const label = timezonesCodeLabelMap[timeZoneItem.code] ? timezonesCodeLabelMap[timeZoneItem.code] : timeZoneItem.code;
                       const timeFormat = `(GMT${timeZoneItem.offset}) ${label}`;
                       const optionProps = {
                           key: timeZoneItem.code,
                           value: timeZoneItem.code,
                       };

                       return <option {...optionProps}>{timeFormat}</option>;
                   })
               }
           </select>
       );
   }

   private changeHandler = (event: ChangeEvent<HTMLSelectElement>) => {
       this.props.onChange(event.target.value);
   };
}

const SelectTimezones = connectGlobalVM<ISelectTimezonesGlobalProps, ISelectTimezonesOwnProps>(
    SelectTimezonesPresentation, vm => {
    return {
        timeZones: vm.getTimezonesVM().getTimezonesList(),
        setSelectedTimezone: vm.getTimezonesVM().setSelectedTimezone
    };
});

export { SelectTimezones };
